import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoShowcase.css';

export const VideoShowcase: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="video-section" id="video">
      <div className="video-container">
        <span className="video-label">{t('video.label')}</span>
        <h2 className="video-title">{t('video.title')}</h2>
        <p className="video-subtitle">{t('video.subtitle')}</p>
        <div className="video-frame">
          <video
            className="video-player"
            src="/careumba-video.mp4"
            poster="/careumba-video-poster.jpg"
            controls
            playsInline
            preload="metadata"
          />
        </div>
      </div>
    </section>
  );
};
